'use strict';
const getAccountTypeInfo = require(('./get-account-type-info'));
module.exports = function cognitoUsernameForLicense(license, subAccountName) {
	const accountTypeInfo = getAccountTypeInfo(license.accountType);
	if (!accountTypeInfo.cognitoAuthenticated) {
		throw new Error('invalid-args');
	}
	if (accountTypeInfo.subAccountRequired && subAccountName) {
		return [license.account, subAccountName].join('/');
	}
	if (license.subAccount && accountTypeInfo.defaultSubAccount !== license.subAccount) {
		return [license.account, license.subAccount].join('/');
	}
	return license.account;
};
